import React, { useState, useEffect, useRef } from 'react';
import Header from './components/Header';
import './App.css';

function App() {
  const [selectedModule, setSelectedModule] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  
  const heroRef = useRef(null);
  const supportRef = useRef(null);
  const billingRef = useRef(null);
  const servicesRef = useRef(null);
  const resourcesRef = useRef(null);
  const updatesRef = useRef(null);

  const handleModuleClick = (module) => {
    setSelectedModule(module);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedModule(null);
  };



  const getModuleTitle = (module) => {
    switch(module) {
      case 'gestion': return '📊 Módulo de Gestión';
      case 'contabilidad': return '💰 Módulo de Contabilidad';
      case 'planilla': return '👥 Módulo de Planilla';
      default: return 'Módulo PACON';
    }
  };

  const getModuleInfo = (module) => {
    switch(module) {
      case 'gestion':
        return (
          <div>
            <h4>Características Principales:</h4>
            <ul>
              <li>✅ Dashboard ejecutivo con KPIs en tiempo real</li>
              <li>✅ Control de inventario con códigos de barras</li>
              <li>✅ Sistema de alertas para stock mínimo</li>
              <li>✅ Integración con proveedores principales</li>
              <li>✅ Reportes de ventas y compras</li>
              <li>✅ Gestión de clientes y proveedores</li>
            </ul>
            <div className="module-stats">
              <div className="stat">
                <span className="stat-number">v2025.1.0</span>
                <span className="stat-label">Versión Actual</span>
              </div>
              <div className="stat">
                <span className="stat-number">50%</span>
                <span className="stat-label">Más Rápido</span>
              </div>
            </div>
          </div>
        );
      case 'contabilidad':
        return (
          <div>
            <h4>Características Principales:</h4>
            <ul>
              <li>✅ Integración completa con SUNAT PLE 2024</li>
              <li>✅ Configuración flexible para diferentes tipos de empresa</li>
              <li>✅ Reportes de costos mejorados con gráficos interactivos</li>
              <li>✅ Exportación a Excel con formato personalizable</li>
              <li>✅ Actualizado según normas NIC y NIIF</li>
              <li>✅ Asistencia inteligente para asientos contables</li>
            </ul>
            <div className="module-stats">
              <div className="stat">
                <span className="stat-number">v2025.1.0</span>
                <span className="stat-label">Versión Actual</span>
              </div>
              <div className="stat">
                <span className="stat-number">100%</span>
                <span className="stat-label">SUNAT Compliant</span>
              </div>
            </div>
          </div>
        );
      case 'planilla':
        return (
          <div>
            <h4>Características Principales:</h4>
            <ul>
              <li>✅ Cálculo automático de gratificaciones</li>
              <li>✅ Generación de boletas de pago digitales</li>
              <li>✅ Integración con AFP y ONP</li>
              <li>✅ Reportes de planilla con filtros avanzados</li>
              <li>✅ Control de vacaciones y licencias</li>
              <li>✅ Generación de Texto Plano para PLAME</li>
            </ul>
            <div className="module-stats">
              <div className="stat">
                <span className="stat-number">v2025.1.0</span>
                <span className="stat-label">Versión Actual</span>
              </div>
              <div className="stat">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Soporte Técnico</span>
              </div>
            </div>
          </div>
        );
      default:
        return <p>Selecciona un módulo para ver su información.</p>;
    }
  };

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrolled = window.pageYOffset;
          const rate = scrolled * -0.3;
          
          if (heroRef.current) {
            heroRef.current.style.transform = `translateY(${rate}px)`;
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Header />
      
      {/* Hero Section */}
      <section id="inicio" className="hero" ref={heroRef}>
        <div className="hero-container">
          <div className="hero-content">
            <h1 className="hero-title gradient-text">
              Programa de Administración PACON
            </h1>
            <p className="hero-subtitle">
              ERP integral para gestión empresarial. Automatiza procesos, optimiza costos y simplifica la administración de tu empresa.
            </p>
            <div className="hero-buttons">
              <button className="btn-primary" onClick={() => document.getElementById('servicios').scrollIntoView({ behavior: 'smooth' })}>
                Ver Sistemas
              </button>
              <button className="btn-secondary" onClick={() => document.getElementById('contacto').scrollIntoView({ behavior: 'smooth' })}>
                Consulta Factura Electrónica
              </button>
            </div>
          </div>
          <div className="hero-image">
            <div className="rotating-logos">
              <img src="PACON2025.png" alt="PACON" className="rotating-logo logo-1" />
              <div 
                className="rotating-logo logo-2 planet-circle planet-gestion"
                onClick={() => handleModuleClick('gestion')}
                title="Click para más información"
              >
                <span className="planet-letter">G</span>
              </div>
              <div 
                className="rotating-logo logo-3 planet-circle planet-contabilidad"
                onClick={() => handleModuleClick('contabilidad')}
                title="Click para más información"
              >
                <span className="planet-letter">C</span>
              </div>
              <div 
                className="rotating-logo logo-4 planet-circle planet-planilla"
                onClick={() => handleModuleClick('planilla')}
                title="Click para más información"
              >
                <span className="planet-letter">P</span>
              </div>
            </div>
            <div className="logo-text-container">
              <span className="logo-text">PACON</span>
              <span className="version-text">v2025.1</span>
            </div>
          </div>
        </div>
        <div className="scroll-indicator">
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* Sistemas Principales Section - MOVIDO ARRIBA */}
      <section id="servicios" className="services" ref={servicesRef}>
        <div className="container">
          <h2 className="section-title">Nuestros Sistemas</h2>
          <div className="services-grid">
            <div className="service-card" onClick={() => handleModuleClick('gestion')}>
              <div className="service-icon">
                <img src="img/gestion.png" alt="Gestión" />
              </div>
              <h3>GESTIÓN <span className="version-badge">v2025.1.0</span></h3>
              <ul>
                <li>Registro de gasto por centro de costos</li>
                <li>Registro de inventario permanente en unidades físicas y valorados</li>
                <li>Dashboard ejecutivo con KPIs en tiempo real</li>
              </ul>
              <div className="click-indicator">
                <i className="fas fa-info-circle"></i> Click para más información
              </div>
            </div>
            <div className="service-card" onClick={() => handleModuleClick('contabilidad')}>
              <div className="service-icon">
                <img src="img/contabilidad.png" alt="Contabilidad" />
              </div>
              <h3>CONTABILIDAD | COSTOS | PRESUPUESTOS <span className="version-badge">v2025.1.0</span></h3>
              <ul>
                <li>Activos, Costos y Presupuestos</li>
                <li>Genera PLE a SUNAT</li>
                <li>Actualizado según normas internacionales de contabilidad (NIC) y las normas internacionales de información financiera (NIIF)</li>
                <li>Integración completa con SUNAT PLE 2024</li>
              </ul>
              <div className="click-indicator">
                <i className="fas fa-info-circle"></i> Click para más información
              </div>
            </div>
            <div className="service-card" onClick={() => handleModuleClick('planilla')}>
              <div className="service-icon">
                <img src="img/planilla.png" alt="Planilla" />
              </div>
              <h3>PLANILLA <span className="version-badge">v2025.1.0</span></h3>
              <ul>
                <li>Genera Texto Plano para el PLAME y AFPNET</li>
                <li>Cálculo automático de gratificaciones</li>
                <li>Integración con AFP y ONP</li>
              </ul>
              <div className="click-indicator">
                <i className="fas fa-info-circle"></i> Click para más información
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Automatización Inteligente Section */}
      <section className="automation" ref={updatesRef}>
        <div className="container">
          <h2 className="section-title">Automatización Inteligente</h2>
          <div className="automation-grid">
            <div className="automation-card">
              <div className="automation-icon">
                <i className="fas fa-robot"></i>
              </div>
              <h3>Procesos Optimizados</h3>
              <p>Reduce el tiempo de tareas repetitivas hasta en un 70% con nuestra tecnología de automatización inteligente.</p>
              <ul>
                <li>✅ Cálculos automáticos de impuestos</li>
                <li>✅ Generación de reportes programados</li>
                <li>✅ Alertas inteligentes de stock</li>
                <li>✅ Backup automático de datos</li>
              </ul>
            </div>
            <div className="automation-card">
              <div className="automation-icon">
                <i className="fas fa-chart-line"></i>
              </div>
              <h3>Análisis Predictivo</h3>
              <p>Anticipa tendencias y toma decisiones informadas con nuestros algoritmos de análisis avanzado.</p>
              <ul>
                <li>✅ Predicción de flujo de caja</li>
                <li>✅ Análisis de patrones de venta</li>
                <li>✅ Alertas de riesgo financiero</li>
                <li>✅ Recomendaciones de optimización</li>
              </ul>
            </div>
            <div className="automation-card">
              <div className="automation-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Seguridad Avanzada</h3>
              <p>Protege tu información con tecnología de encriptación de nivel bancario y respaldos automáticos.</p>
              <ul>
                <li>✅ Encriptación AES-256</li>
                <li>✅ Respaldo automático cada 4 horas</li>
                <li>✅ Control de acceso por roles</li>
                <li>✅ Auditoría completa de cambios</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Actualizaciones del Sistema Section */}
      <section className="updates" ref={updatesRef}>
        <div className="container">
          <h2 className="section-title">Últimas Actualizaciones</h2>
          <div className="updates-container">
            <div className="updates-window">
              <div className="window-header">
                <div className="window-controls">
                  <span className="control red"></span>
                  <span className="control yellow"></span>
                  <span className="control green"></span>
                </div>
                <span className="window-title">PACON v2025.1 - Actualizaciones</span>
              </div>
              <div className="window-content">
                <div className="update-item">
                  <div className="update-header">
                    <span className="update-date">📅 15 Julio 2024</span>
                    <span className="update-version">v2025.1.0</span>
                  </div>
                  <h4>🔄 Sistema Contable - Nuevas Funcionalidades</h4>
                  <ul>
                    <li>✅ Integración completa con SUNAT PLE 2024</li>
                    <li>✅ Nuevo módulo de facturación electrónica automática</li>
                    <li>✅ Reportes de costos mejorados con gráficos interactivos</li>
                    <li>✅ Exportación a Excel con formato personalizable</li>
                  </ul>
                </div>
                <div className="update-item">
                  <div className="update-header">
                    <span className="update-date">📅 10 Julio 2024</span>
                    <span className="update-version">v2025.1.0</span>
                  </div>
                  <h4>📊 Módulo de Gestión - Optimizaciones</h4>
                  <ul>
                    <li>✅ Dashboard ejecutivo con KPIs en tiempo real</li>
                    <li>✅ Control de inventario con códigos de barras</li>
                    <li>✅ Sistema de alertas para stock mínimo</li>
                    <li>✅ Integración con proveedores principales</li>
                  </ul>
                </div>
                <div className="update-item">
                  <div className="update-header">
                    <span className="update-date">📅 05 Julio 2024</span>
                    <span className="update-version">v2025.1.0</span>
                  </div>
                  <h4>👥 Módulo de Planilla - Mejoras</h4>
                  <ul>
                    <li>✅ Cálculo automático de gratificaciones</li>
                    <li>✅ Generación de boletas de pago digitales</li>
                    <li>✅ Integración con AFP y ONP</li>
                    <li>✅ Reportes de planilla con filtros avanzados</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="updates-info">
              <h3>🚀 ¿Por qué actualizar?</h3>
              <div className="benefits-list">
                <div className="benefit-item">
                  <i className="fas fa-shield-alt"></i>
                  <div>
                    <h4>Seguridad Mejorada</h4>
                    <p>Encriptación de datos y respaldos automáticos</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <i className="fas fa-rocket"></i>
                  <div>
                    <h4>Rendimiento Optimizado</h4>
                    <p>50% más rápido en procesamiento de datos</p>
                  </div>
                </div>
                <div className="benefit-item">
                  <i className="fas fa-headset"></i>
                  <div>
                    <h4>Soporte 24/7</h4>
                    <p>Asistencia técnica especializada disponible</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Soporte en Línea Section */}
      <section className="support" ref={supportRef}>
        <div className="container">
          <div className="support-card">
            <h2>PACON Soporte en Línea</h2>
            <div className="anydesk-section">
              <img src="https://anydesk.com/_static/img/logos/anydesk-logo-40fe6c.svg" alt="AnyDesk" className="anydesk-logo" />
              <a href="https://anydesk.com" target="_blank" rel="noopener noreferrer">
                <button className="btn-download">
                  <i className="fas fa-download"></i> Descargar AnyDesk
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Facturación Electrónica Section */}
      <section className="electronic-billing" ref={billingRef}>
        <div className="container">
          <div className="billing-card">
            <div className="billing-icon">
              <img src="img/fac.png" alt="Facturación Electrónica" />
            </div>
            <div className="billing-content">
              <h3>FACTURA ELECTRÓNICA</h3>
              <div className="billing-links">
                <a href="http://www.sunat.gob.pe/padronobligados.html" target="_blank" rel="noopener noreferrer">
                  ¿Quiénes están obligados a emitir comprobantes de pago electrónicos?
                </a>
                <a href="mailto:ventas@pacon.com.pe">
                  Solicite Cotización
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Manuales y Videos Section */}
      <section className="resources" ref={resourcesRef}>
        <div className="container">
          <div className="resources-grid">
            <div className="manuals-section">
              <h3>MANUALES</h3>
              <ul>
                <li>
                  <i className="fas fa-file-pdf"></i>
                  <a href="manualpacon/PROCESO-BCE-COMP-2016-PACON-A-PDT.pdf" target="_blank">
                    PROCESOS PARA INGRESAR EL BALANCE DE COMPROBACION DEL SISTEMA PACON AL PDT SUNAT
                  </a>
                </li>
                <li>
                  <i className="fas fa-file-pdf"></i>
                  <a href="manualpacon/proceso-dif-camb-cierre-ejercicio-2016.pdf" target="_blank">
                    Diferencia cambio y cierre
                  </a>
                </li>
                <li>
                  <i className="fas fa-file-pdf"></i>
                  <span className="coming-soon">
                    Como Enviar Certificado Digital, para la Facturación Electrónica SUNAT
                    <span className="badge">Próximamente</span>
                  </span>
                </li>
                <li>
                  <i className="fas fa-file-pdf"></i>
                  <a href="manualpacon/MANUAL-VENTA-CON-NOTA-CREDITO.pdf" target="_blank">
                    Asiento de una Venta, con Nota de Crédito
                  </a>
                </li>
              </ul>
            </div>
            <div className="videos-section">
              <h3>VIDEOS TUTORIALES</h3>
              <div className="video-list">
                <div className="video-item">
                  <h4>SISTEMA CONTABLE PACON (FACILIDADES QUE OFRECE)</h4>
                  <iframe src="https://www.youtube.com/embed/ExWpeGUnLGQ" frameborder="0" allowfullscreen title="Sistema Contable PACON"></iframe>
                </div>
                <div className="video-item">
                  <h4>PACON CREACION Y ELIMINACION DE EMPRESAS</h4>
                  <iframe src="https://www.youtube.com/embed/K1YeTV7vzmM" frameborder="0" allowfullscreen title="PACON Creación y Eliminación de Empresas"></iframe>
                </div>
                <div className="video-item">
                  <h4>PACON REGISTRO DE VENTAS</h4>
                  <iframe src="https://www.youtube.com/embed/tmnWM3Y3UW0" frameborder="0" allowfullscreen title="PACON Registro de Ventas"></iframe>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Compacto */}
      <footer id="contacto" className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>PACON</h4>
              <p>📱 #998076316 | #948800378</p>
              <p>📧 ventas@pacon.com.pe</p>
            </div>
            <div className="footer-section">
              <h4>Horario</h4>
              <p>Lun-Vie: 9am-6pm</p>
              <p>Sáb: 9am-1pm</p>
            </div>
            <div className="footer-section">
              <h4>Tutoriales</h4>
              <a href="https://www.youtube.com/watch?v=ExWpeGUnLGQ&list=PLEK_1uLaiRz1dxozpzWGa6K7J9TEwgNXe" target="_blank" rel="noopener noreferrer">
                <i className="fab fa-youtube"></i> YouTube
              </a>
            </div>
          </div>
        </div>
      </footer>

      {/* Modal de Información */}
      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{getModuleTitle(selectedModule)}</h3>
              <button className="modal-close" onClick={closeModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body">
              {getModuleInfo(selectedModule)}
            </div>
            <div className="modal-footer">
              <button className="btn-primary" onClick={closeModal}>
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Soporte Flotante */}
      <div className="floating-support">
        <h3 className="support-title">PACON Soporte</h3>
        <div className="anydesk-section">
          <img src="https://anydesk.com/_static/img/logos/anydesk-logo-40fe6c.svg" alt="AnyDesk" className="anydesk-logo" />
          <a href="https://anydesk.com" target="_blank" rel="noopener noreferrer">
            <button className="btn-download">
              <i className="fas fa-download"></i>
              <span className="btn-text">AnyDesk</span>
            </button>
          </a>
          <p className="support-info">
            <i className="fas fa-info-circle"></i>
            <span className="info-text">Conectamos directamente a tu máquina para brindarte soporte técnico inmediato</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default App;
